<template>
  <div class="compteClair aide-conteneur-parent col-md-5 px-0 h-100">
    <template v-if="aide.isAideActif">
      <!-- Affichage Mobile -->
      <div v-if="isMobile">
        <b-modal
          id="modal-aide"
          :hide-footer="true"
          :visible="true"
          content-class="modal-content-aide h-100 w-100 px-0"
          header-class="conteneur-secondaire pb-0 pr-0"
          body-class="conteneur-secondaire mw-100 h-100"
          dialog-class="modal-dialog-aide conteneur-secondaire h-100"
          modal-class="compteClair"
          @hidden="toggleAide()"
        >
          <template #modal-header="{ hide }">
            <div class="contenu-modal" :style="styleContenuModal">
              <div class="row posBtnFermerAide">
                <button class="btnVide" @click="hide()">
                  <svg-icon
                    icon-name="icone-fermer-mince"
                    color="$couleur-primaire"
                    className="iconeFermer"
                  ></svg-icon>
                </button>
              </div>
            </div>
            <h2 class="grandTitre text-left mt-n3 mb-2 pl-md-2 pl-xl-4">{{ $t('aide') }}</h2>
          </template>
          <AideContenu :idRubriqueAide="idRubriqueAide" @close="toggleAide"></AideContenu>
        </b-modal>
      </div>
      <!-- Affichage Desktop -->
      <div v-else class="h-100 d-flex conteneur-secondaire w-40">
        <div class="m-3 align-content-center">
          <b-modal
            id="modal-aide"
            :hide-footer="true"
            :visible="true"
            dialog-class="modal-dialog-aide conteneur-secondaire"
            content-class="modal-content-aide h-100 w-100"
            header-class="conteneur-secondaire pb-0 pl-2 pr-0"
            body-class="conteneur-secondaire mw-100 h-100 pt-0"
            modal-class="compteClair"
            @hidden="toggleAide()"
          >
            <template #modal-header="{ hide }">
              <div class="contenu-modal" :style="styleContenuModal">
                <div class="row posBtnFermerAide">
                  <button class="btnVide" @click="hide()">
                    <svg-icon
                      icon-name="icone-fermer-mince"
                      color="$couleur-primaire"
                      className="iconeFermer"
                    ></svg-icon>
                  </button>
                </div>
              </div>
              <h2 class="grandTitre text-left mt-n3 mb-2 pl-0 pl-md-2 pl-xl-4">{{ $t('aide') }}</h2>
            </template>
            <AideContenu :idRubriqueAide="idRubriqueAide"></AideContenu>
          </b-modal>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import AideContenu from '@/components/AideContenu';

import { isJelMobile, getCurrentLanguage } from '@/helpers/AppHelpers';

export default {
  name: 'Aide',
  components: { AideContenu },
  props: ['idRubriqueAide'],
  data() {
    return {
      espacementSupplementaireContenu: 20,
    };
  },
  computed: {
    ...mapState(['aide']),
    isMobile() {
      return isJelMobile();
    },
    styleContenuModal() {
      if (this.$store.state.navigation.barrePCU) {
        // Avec l'ajout de la barre PCU, le contenu de la modale se retrouve caché par la barre blanche en entête
        // Ici on recupère la hauteur de la barre blanche pour savoir de combien de pixel décaller le contenu.
        const offsetTop =
          getCurrentLanguage() == 'en'
            ? document.getElementById('headerPortailEspaceJeux').offsetTop
            : 0;
        const espacementContenu =
          document.getElementById('headerPortailEspaceJeux').offsetHeight +
          offsetTop +
          this.espacementSupplementaireContenu;
        return `margin-top:${espacementContenu}px;`;
      }
      return '';
    },
  },
  beforeDestroy() {
    if (this.$store.state.aide.isAideActif) {
      this.$store.commit('aide/SET_IS_AIDE_ACTIF', false);
    }
  },
  methods: {
    toggleAide() {
      this.$store.dispatch('aide/toggleAide');
    },
  },
};
</script>
